import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useAuth } from './../../util/auth';

function AuthForm(props) {
  const auth = useAuth();

  const [pending, setPending] = useState(false);
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const submitHandlersByType = {
    signin: ({ email, pass }) => {
      return auth.signin(email, pass).then(user => {
        props.onAuth?.(user);
      });
    },
    signup: ({ email, pass }) => {
      return auth.signup(email, pass).then(user => {
        props.onAuth?.(user);
      });
    },
    forgotpass: ({ email }) => {
      return auth.sendPasswordResetEmail(email, props.afterAuthPath).then(() => {
        setPending(false);
        props.onFormAlert({
          type: 'success',
          message: 'Password reset email sent',
        });
      });
    },
    changepass: ({ pass }) => {
      return auth.confirmPasswordReset(pass).then(() => {
        setPending(false);
        props.onFormAlert({
          type: 'success',
          message: 'Your password has been changed',
        });
        if (props.afterAuthPath) {
          props.onAuth?.();
        }
      });
    },
  };

  const onSubmit = ({ email, pass }) => {
    setPending(true);

    submitHandlersByType[props.type]({
      email,
      pass,
    }).catch(error => {
      setPending(false);
      props.onFormAlert({
        type: 'error',
        message: error.message,
      });
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 font-oswald">
      {['signup', 'signin', 'forgotpass'].includes(props.type) && (
        <div className="mb-2">
          <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
            Email Address
          </label>
          <input
            className="py-1 px-3 w-full leading-8 bg-white rounded border border-gray-300 outline-none focus:border-blue-500 focus:ring-1"
            name="email"
            type="email"
            {...register('email', { required: 'Please enter an email' })}
          />

          {errors.email && (
            <p className="mt-1 text-sm text-left text-red-600">{errors.email.message}</p>
          )}
        </div>
      )}

      {['signup', 'signin', 'changepass'].includes(props.type) && (
        <div className="mb-2">
          <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
            Password
          </label>
          <input
            className="py-1 px-3 w-full leading-8 bg-white rounded border border-gray-300 outline-none focus:border-blue-500 focus:ring-1"
            name="pass"
            type="password"
            {...register('pass', { required: 'Please enter a password' })}
          />

          {errors.pass && (
            <p className="mt-1 text-sm text-left text-red-600">{errors.pass.message}</p>
          )}
        </div>
      )}

      {['signup', 'changepass'].includes(props.type) && (
        <div className="mb-2">
          <input
            className="py-1 px-3 w-full leading-8 bg-white rounded border border-gray-300 outline-none focus:border-blue-500 focus:ring-1"
            name="confirmPass"
            type="password"
            placeholder="Confirm Password"
            {...register('confirmPass', {
              required: 'Please enter your password again',
              validate: value => {
                if (value === getValues().pass) {
                  return true;
                } else {
                  return 'Passwords do not match';
                }
              },
            })}
          />

          {errors.confirmPass && (
            <p className="mt-1 text-sm text-left text-red-600">{errors.confirmPass.message}</p>
          )}
        </div>
      )}

      <button
        className="flex w-full justify-center rounded-md bg-dark-red px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-red focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red"
        type="submit"
        disabled={pending}
      >
        {pending ? '...' : props.buttonAction}
      </button>
    </form>
  );
}

export default AuthForm;
